import React, { useCallback } from 'react';
import { RAZORPAY_KEY_ID } from '../../config/razorpayConfig';

export const PaymentLayout = ({
  children,
  orderId, // Required: Order ID from backend (e.g., "order_RtpDvww4WAr3Sx")
  bookingId, // Required: Booking ID from backend for updating after payment
  amount = 50000, // amount in paise (500 INR)
  currency = 'INR',
  name = 'Hobi App',
  description = 'Payment for services',
  prefill = {}, // Optional: { name, email, contact }
  onSuccess,
  onFailure,
  onInitiate,
  disabled = false,
  
}) => {
  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      if (window.Razorpay) {
        resolve(true);
        return;
      }
      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const handlePayment = useCallback(async (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    
    if (disabled) return;

    let currentOrderId = orderId;
    let currentBookingId = bookingId;
    let currentAmount = amount;

    // If onInitiate is provided, we fetch order details first
    if (onInitiate) {
      const data = await onInitiate();
      if (!data) return; // Initiation failed
      currentOrderId = data.orderId;
      currentBookingId = data.bookingId;
      // currentAmount = data.amount;
    }

    if (!currentOrderId) {
      console.error('Order ID is required for payment');
      alert('Order ID is missing. Please try again.');
      return;
    }

    const isLoaded = await loadRazorpayScript();
    if (!isLoaded) {
      alert('Razorpay SDK failed to load. Please check your connection.');
      return;
    }

    const options = {
      key: RAZORPAY_KEY_ID,
      amount: currentAmount,
      currency: currency,
      name: name,
      description: description,
      order_id: currentOrderId,
      handler: function (response) {
        console.log('Payment Success:', response);
        if (onSuccess) {
          onSuccess({
            ...response,
            bookingId: currentBookingId,
            transactionId: response.razorpay_payment_id,
          });
        }
      },
      prefill: {
        name: prefill.name || '',
        email: prefill.email || '',
        contact: prefill.contact || '',
      },
      theme: {
        color: '#ff7e5f',
      },
      modal: {
        ondismiss: function () {
          console.log('Payment dismissed');
          if (onFailure) {
            onFailure({ reason: 'dismissed', bookingId: currentBookingId });
          }
        },
      },
    };

    const razorpay = new window.Razorpay(options);
    razorpay.on('payment.failed', function (response) {
      console.log('Payment Failed:', response.error);
      if (onFailure) {
        onFailure({
          ...response.error,
          bookingId: currentBookingId,
        });
      }
    });
    razorpay.open();
  }, [orderId, bookingId, amount, currency, name, description, prefill, onSuccess, onFailure, disabled, onInitiate]);

  return (
    <div 
      onClick={handlePayment} 
      style={{ 
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.6 : 1,
      }}
    >
      {children}
    </div>
  );
};
